import React from "react"
import styled from "styled-components"
import { theme } from "Theme"

export const Content = styled.div`
  display: block;
  padding: 4rem 1rem;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  color: ${({ mode }) => (mode === "dark" ? theme.colors.white.base : theme.colors.black.base)};
  background-color: ${({ mode }) => (mode === "dark" ? theme.colors.black.base : theme.colors.white.base)};
  @media (min-width: ${theme.breakpoints.s}) {
    padding: 4rem 2rem;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const EventCard = ({ children, eventType, eventTime, eventPanel, region, brand, month, ...other }) => {
  return (
    <div
      eventType={eventType}
      eventTime={eventTime}
      eventPanel={eventPanel}
      region={region}
      brand={brand}
      month={month}
      {...other}>
      {children}
    </div>
  )
}

export default EventCard
